const ANALYTICS_ID = 'G-DKNP3SQC26';

const appendScript = (src, id) => new Promise((resolve, reject) => {
  if (document.getElementById(id)) return resolve();
  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  script.onload = resolve;
  script.onerror = reject;
  document.head.appendChild(script);
});

export const loadAnalytics = async () => {
  if (typeof window === 'undefined' || window.__tresAnalyticsLoaded) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', ANALYTICS_ID, { send_page_view: false });
  try { await appendScript(`https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`, 'tres-analytics'); } catch (error) { console.warn('Analytics unavailable', error); }
  window.__tresAnalyticsLoaded = true;
};

export const trackEvent = (name, parameters = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag('event', name, parameters);
};

export const loadRecaptcha = async (siteKey) => {
  if (typeof window === 'undefined') return null;
  if (!window.grecaptcha) {
    try { await appendScript(`https://www.google.com/recaptcha/api.js?render=${siteKey}`, 'tres-recaptcha'); } catch (error) { return null; }
  }
  return new Promise((resolve) => window.grecaptcha.ready(() => resolve(window.grecaptcha)));
};
